import React, { useState, useEffect } from "react";
import ArrowDropDownTwoToneIcon from '@mui/icons-material/ArrowDropDownTwoTone';
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import SearchIcon from '@mui/icons-material/Search';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import calender from './assets/Images/calender.png';
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import { Box, TextField, Typography, Button, Table, Popper, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Grid, Card, CardContent, IconButton, Menu, MenuItem } from "@mui/material";
import favicon from './assets/Images/favicon.png';
import logo from './assets/Images/logo.png';
import ProductTable from './ProductTable';
import Invoice from "./InvoiceApp";
import axios from "axios"; // Import axios for API calls
import { useMediaQuery } from "@mui/material";

const StyledButton = styled(Button)({
  fontFamily: "Caladea, serif",
  fontWeight: "bold",
  backgroundColor: "#fdb913",
  border: "1px solid",
  color: "black",
  "&:hover": {
    backgroundColor: "#fdb913",
  },
});

const BillHistory = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTab = useMediaQuery("(max-width:1024px)");
  const isMobileOrTab = isMobile || isTab;

  const invoices = [
  ];
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState([]); // Initialize as an empty array
  const [selectedDate, setSelectedDate] = useState(null);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [filteredInvoicesState, setFilteredInvoicesState] = useState(invoices);

  const [anchorEl, setAnchorEl] = useState(null);
  const [invoiceBills, setInvoiceBills] = useState([]); // All bills
  const [filteredInvoiceBills, setFilteredInvoiceBills] = useState([]); // Filtered bills
  const [selectedInvoiceProducts, setSelectedInvoiceProducts] = useState([]); // State to store selected invoice products
  const [data, setData] = useState([
    { label: 'Total New Customers', value: 0 },
    { label: 'Total Regular Customers', value: 0 },
    { label: 'Total Product Count', value: 0 },
    { label: 'Total product Tax', value: 0 },
    { label: 'Total Product VAT', value: 0 },
    { label: 'Total Product Income', value: '0/-' },
  ]);

  const handleViewClick = (invoice) => {
    setSelectedInvoice(invoice); // Set the selected invoice
    setSelectedInvoiceProducts(invoice.products || []); // Set the products of the selected invoice
  };

  const handleSearch = () => {
    const filtered = invoiceBills.filter(bill =>
      bill.invoiceNo.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredInvoiceBills(filtered);
  };
  const [selectedTab, setSelectedTab] = useState("supplied");

  const handleDateClick = (event) => {
    setDateAnchorEl(dateAnchorEl ? null : event.currentTarget);
  };
  const handleMonthClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDateChange = (date) => {
    if (date) {
      const formattedDate = dayjs(date).format("YYYY-MM-DD"); // Format to match bill.date
      const filtered = invoiceBills.filter(bill => {
        // Ensure both dates are in the same format for comparison
        return dayjs(bill.date).format("YYYY-MM-DD") === formattedDate;
      });
      setFilteredInvoiceBills(filtered); // Update filtered results
    }
    setSelectedDate(date);
    setOpenDatePicker(false);
  };

  useEffect(() => {
    console.log(selectedDate, openDatePicker);
  }, [selectedDate, openDatePicker]);

  const handleMonthClose = (month) => {
    setAnchorEl(null);
    if (month) {
      const filtered = invoiceBills.filter(bill => {
        // bill.date should be in a parseable format
        const billMonth = new Date(bill.date).toLocaleString('default', { month: 'long' });
        return billMonth === month;
      });
      setFilteredInvoiceBills(filtered);
    }
  };
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  React.useEffect(() => {
    setSelectedProduct({
      date: "2024-12-20",
      product: "Default Product",
      update: 20,
      previous: 20,
      avgCount: 2,
      discount: 120,
      vat: 2,
      price: 120,
      category: "Indian",
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const invoiceResponse = await axios.get("https://enzo-matr.onrender.com/api/invoice_bills");
        setInvoiceBills(invoiceResponse.data);
        setFilteredInvoiceBills(invoiceResponse.data); // Initialize filtered bills

        const totalNewCustomers = invoiceResponse.data.filter(
          bill => bill.customerState === "New Customer"
        ).length;

        const totalRegularCustomers = invoiceResponse.data.filter(
          bill => bill.customerState === "Regular"
        ).length;

        const totalProductIncome = invoiceResponse.data.reduce(
          (sum, bill) => sum + parseFloat(bill.totalPrice || 0), 0
        );

        // Fetch total product count from the backend
        const productCountResponse = await axios.get("https://enzo-matr.onrender.com/api/products/total-count");
        const totalProductCount = productCountResponse.data.totalProductCount;

        // Fetch total VAT from the backend
        const productVATResponse = await axios.get("https://enzo-matr.onrender.com/api/products/total-vat");
        const totalProductVAT = productVATResponse.data.totalProductVAT;

        // Update the data array with calculated values
        setData([
          { label: 'Total New Customers', value: totalNewCustomers },
          { label: 'Total Regular Customers', value: totalRegularCustomers },
          { label: 'Total Product Count', value: totalProductCount },
          { label: 'Total product Tax', value: totalProductVAT }, // Update if you have tax data
          { label: 'Total Product VAT', value: 0 },
          { label: 'Total Product Income', value: `${totalProductIncome.toFixed(2)}/-` },
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <Paper
      sx={{
        background: "#eeecec",
        width: "100vw",
        height: "100vh",           // Use height instead of minHeight
        boxSizing: "border-box",
        overflow: "auto",          // Allow internal scroll if needed
        position: "fixed",         // Fix to viewport
      }}
    >
      <div style={{
        fontFamily: "caladea",
        width: isMobileOrTab ? "100%" : "99.4%", // Responsive width
        background: "#fdb913",
        height: isMobileOrTab ? "28px" : "35px", // Responsive height
        padding: 4,
        textAlign: "center",
        fontSize: isMobileOrTab ? "20px" : "30px", // Responsive font size
        color: "white",
        fontWeight: "bold"
      }}>
        BILL HISTORY
      </div>
      <Box
        sx={{
          display: isMobileOrTab ? "block" : "flex",
          alignItems: "center",
          justifyContent: "center",
          gap:  2,
          mt: 0.9
        }}
      >
        <Button
          sx={{
            width: isMobileOrTab ? "100%" : "650px",
            height: "38px",
            fontSize: "18px",
            bgcolor: selectedTab === "supplied" ? "black" : "#fdb913",
            borderRadius: "10px",
            color: "white",
            fontWeight: "bold",
            fontFamily: "'Bricolage Grotesque', sans-serif",
          }}
          onClick={() => setSelectedTab("supplied")}
        >
          SUPPLIED PRODUCT
        </Button>
        <Button
          sx={{
            width: isMobileOrTab ? "100%" : "650px",
            height: "38px",
            fontSize: "18px",
            bgcolor: selectedTab === "purchased" ? "black" : "#fdb913",
            borderRadius: "10px",
            color: "white",
            mt: isMobileOrTab ? 1 : 0,
            fontWeight: "bold",
            fontFamily: "'Bricolage Grotesque', sans-serif",
          }}
          onClick={() => setSelectedTab("purchased")}
        >
          PURCHASED PRODUCT
        </Button>
      </Box>
      {selectedTab === "supplied" && (
        <Grid
          container
          spacing={isMobileOrTab ? 0.5 : 1}
          sx={{
            padding: isMobileOrTab ? 0.5 : 1,
            flexDirection: isMobileOrTab ? "column" : "row",
          }}
        >
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              marginBottom: isMobileOrTab ? "8px" : "1px",
              marginLeft: isMobileOrTab ? 0 : 2.3,
              width: isMobileOrTab ? "100%" : "920px",
            }}
          >
            <Card
              sx={{
                borderRadius: "10px",
                height: isMobileOrTab ? "600px" : "calc(100vh - 170px)", // Adjust 180px as needed for header/other content
                padding: isMobileOrTab ? "4px" : "1px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CardContent sx={{ flex: "1 1 auto", display: "flex", flexDirection: "column", minHeight: 0 }}>
                <div style={{ display: "flex", flexDirection: "row", gap: 1, margin: 2, marginBottom: "6px" }}>
                  <TextField
                    variant="outlined"
                    placeholder="Search Invoice No"
                    size="small"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                      sx: { borderRadius: "10px", border: "1px solid", width: "290px" }
                    }}
                  />
                  <IconButton
                    sx={{ background: "black", color: "white", borderRadius: "10px", height: "42px", ml: 1 }}
                    onClick={handleSearch}
                  >
                    <SearchIcon />
                  </IconButton>
                  <Button
                    variant="contained"
                    endIcon={<ArrowDropDownTwoToneIcon style={{ fontSize: "30px", color: "black" }} />}
                    sx={{ background: "#fdb913", height: "42px", fontFamily: "caladea", color: "black", textTransform: "none", border: "1px solid", borderRadius: "10px", width: "200px", ml: 1, fontSize: "18px", fontWeight: "bold" }}
                    onClick={handleMonthClick}
                  >
                    Sort By month
                  </Button>
                  < Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => handleMonthClose(null)}
                  >
                    {months.map((month, index) => (
                      <MenuItem
                        key={index} onClick={() => handleMonthClose(month)}>
                        {month}
                      </MenuItem>
                    ))}
                  </Menu>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <StyledButton onClick={handleDateClick}
                      sx={{
                        textTransform: "none",
                        height: "42px",
                        width: "200px",
                        ml: 1,
                        fontSize: "20px",
                        borderRadius: "10px"
                      }}
                      endIcon={
                        <img src={calender} alt="calander" height={25} />
                      }
                    >Select Date</StyledButton>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => {
                        setFilteredInvoiceBills(invoiceBills);
                        setDateAnchorEl(null);
                      }}
                      sx={{
                        minWidth: 116,
                        height: "42px",
                        background: "black",
                        borderRadius: "10px",
                        ml: 1,
                        fontSize: "20px",
                        textTransform: "none",
                        fontFamily: "caladea",
                        color: "#fff",
                        fontWeight: "bold",
                        "&:hover": { background: "#9e9e9e" }
                      }}
                    >
                      View All
                    </Button>

                    <Popper open={Boolean(dateAnchorEl)} anchorEl={dateAnchorEl} placement="bottom-start">
                      <Paper sx={{ p: 1 }}>
                        <DateCalendar onChange={handleDateChange} />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => setDateAnchorEl(null)}
                            sx={{ minWidth: 80 }}
                          >
                            Close
                          </Button>
                        </Box>
                      </Paper>
                    </Popper>
                  </LocalizationProvider>
                </div>
                <Box sx={{ background: "#000", borderRadius: "10px" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {["Invoice No", "Date", "Time", "Total Items", "Total Price", "Delivery Type", "Payment Type", "View"].map((heading, index) => (
                          <TableCell
                            key={index}
                            sx={{
                              color: "white",
                              fontWeight: "bold",
                              textAlign: "center",
                              padding: "10px",
                              fontFamily: "'Bricolage Grotesque',sans-serif",
                              fontSize: "16px"
                            }}
                          >
                            {heading}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                  </Table>
                </Box>
                <TableContainer
                  component={Paper}
                  sx={{
                    flex: "1 1 auto",
                    minHeight: 0,
                    overflowY: "auto",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                    "&::-webkit-scrollbar": { display: "none" },
                  }}>
                  <Table>
                    <TableBody>
                      {filteredInvoiceBills.map((bill, index) => (
                        // Use filteredInvoicesState for rendering
                        <TableRow key={index}>
                          <TableCell sx={{ textAlign: "left", fontSize: "10px" }}>{bill.invoiceNo}</TableCell>
                          <TableCell>{bill.date}</TableCell>
                          <TableCell sx={{ textAlign: "center" }}>{bill.time}</TableCell>
                          <TableCell sx={{ textAlign: "center" }}>{bill.totalItems}</TableCell>
                          <TableCell sx={{ textAlign: "center" }}>{bill.totalPrice}</TableCell>
                          <TableCell sx={{ textAlign: "center" }}>{bill.deliveryType}</TableCell>
                          <TableCell sx={{ textAlign: "center" }}>{bill.paymentType}</TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <IconButton
                              onClick={() => handleViewClick(bill)}
                              sx={{
                                background: "#FFC107",
                                width: "30px",
                                height: "30px",
                                borderRadius: "5px",
                                "&:hover": { background: "black" },
                              }}
                            >
                              <img src={favicon} alt="Favicon" style={{ width: "18px" }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 1,
              marginLeft: "20px", // or another small value
              marginTop: 0,
              width: "390px",
              // Remove position and right
            }}
          >
            <Card
              sx={{
                height: isMobileOrTab ? "auto" : "260px",
                width: isMobileOrTab ? "700px": "380px", // <--- Change this to a fixed width if needed
                marginLeft: 0,
              }}
            >
              <CardContent id="printable-area" sx={{ padding: 1 }}>
                <div style={{ display: 'flex', width: '100%' }}>
                  <img src={logo} alt="Logo" style={{ width: 60, marginLeft: "50px" }} />
                  <Typography variant="h6" sx={{ textAlign: "center", fontFamily: "source serif pro", fontSize: "24px", fontWeight: "bold", mt: '5px' }}> Enzo Management</Typography></div>
                <Typography variant="subtitle2" sx={{ textAlign: "center", fontFamily: "cardo" }}>Life Changes Ind.</Typography>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                  <Typography variant="body2" sx={{ textAlign: "left" }}>Invoice No: {selectedInvoice ? selectedInvoice.invoiceNo : "N/A"}</Typography>
                  <Typography variant="body2" sx={{ textAlign: "right" }}>{selectedInvoice ? selectedInvoice.date : "N/A"}</Typography>
                </div>
                <Invoice selectedProduct={selectedInvoiceProducts} /> {/* Pass selected products to InvoiceApp */}
              </CardContent>
            </Card>
            <Card
              sx={{
                border: "2px solid #FFD700",
                borderRadius: "8px",
                boxShadow: 2,
                height: isMobileOrTab ? "auto" : "190px",
                width: isMobileOrTab ? "700px" : "380px",
                marginLeft: 0,
              }}
            >
              <CardContent>
                {data.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "4px 0",
                      borderBottom: index !== data.length - 1 ? "1px solid #FFD700" : "none",
                    }}
                  >
                    <span style={{ fontWeight: "bold", fontSize: "14px", color: "#333", marginLeft: "20px" }}>
                      {item.label}
                    </span>
                    <span style={{ fontSize: "14px", color: "#000", marginRight: "20px" }}>{item.value}</span>
                  </div>
                ))}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
      {selectedTab === "purchased" && (
        <Grid container spacing={isMobileOrTab ? 0.5 : 2} sx={{ padding: isMobileOrTab ? 0.5 : 1, flexDirection: isMobileOrTab ? "column" : "row" }}>
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              marginBottom: isMobileOrTab ? "8px" : "-6px",
              marginLeft: isMobileOrTab ? 0 : "2px",
              gap: 1,
              width: isMobileOrTab ? "100%" : "940px",
            }}
          >
            <ProductTable onSelectProduct={(products) => setSelectedProduct(products)} />
            {/* Show Invoice and Totals below table only on mobile/tab */}
            {isMobileOrTab && (
              <>
                <Card sx={{ mt: 2, borderRadius: "10px", width: "100%", }}>
                  <CardContent id="printable-area" sx={{ padding: 1 }}>
                    <div style={{ display: 'flex', width: '100%' }}>
                      <img src={logo} alt="Logo" style={{ width: 60, marginLeft: "50px" }} />
                      <Typography variant="h6" sx={{ textAlign: "center", fontFamily: "source serif pro", fontSize: "24px", fontWeight: "bold", mt: '5px' }}> Enzo Management</Typography>
                    </div>
                    <Typography variant="subtitle2" sx={{ textAlign: "center", fontFamily: "cardo" }}>Life Changes Ind.</Typography>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                      <Typography variant="body2" sx={{ textAlign: "left" }}>Invoice No: {selectedInvoice ? selectedInvoice.invoiceNo : "N/A"}</Typography>
                      <Typography variant="body2" sx={{ textAlign: "right" }}>{selectedInvoice ? selectedInvoice.date : "N/A"}</Typography>
                    </div>
                    <Invoice selectedProduct={selectedProduct} />
                  </CardContent>
                </Card>
                <Card sx={{ border: "2px solid #FFD700", borderRadius: "8px", boxShadow: 2, mt: 2, width: "100%" }}>
                  <CardContent>
                    {data.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "4px 0",
                          borderBottom: index !== data.length - 1 ? "1px solid #FFD700" : "none",
                        }}
                      >
                        <span style={{ fontWeight: "bold", fontSize: "14px", color: "#333", marginLeft: "20px" }}>
                          {item.label}
                        </span>
                        <span style={{ fontSize: "14px", color: "#000", marginRight: "20px" }}>{item.value}</span>
                      </div>
                    ))}
                  </CardContent>
                </Card>
              </>
            )}
          </Grid>
          {/* Desktop: Invoice and Totals remain on the right */}
          {!isMobileOrTab && (
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 1,
                marginLeft: "110px", // or another small value
                marginTop: 0,
                width: "390px",
                // Remove position and right
              }}
            >
              <Card sx={{ height: "260px", width: "390px", marginLeft: isMobileOrTab? 0 : "-100px"  }}>  
                <CardContent id="printable-area" sx={{ padding: 1, mr: 3 }}>
                  <div style={{ display: 'flex', width: '100%' }}>
                    <img src={logo} alt="Logo" style={{ width: 60, marginLeft: "50px" }} />
                    <Typography variant="h6" sx={{ textAlign: "center", fontFamily: "source serif pro", fontSize: "24px", fontWeight: "bold", mt: '5px' }}> Enzo Management</Typography>
                  </div>
                  <Typography variant="subtitle2" sx={{ textAlign: "center", fontFamily: "cardo" }}>Life Changes Ind.</Typography>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Typography variant="body2" sx={{ textAlign: "left" }}>Company Name: {selectedInvoice ? selectedInvoice.invoiceNo : "N/A"}</Typography>
                    <Typography variant="body2" sx={{ textAlign: "right" }}>{selectedInvoice ? selectedInvoice.date : "N/A"}</Typography>
                  </div>
                  <Invoice selectedProduct={selectedProduct} />
                </CardContent>
              </Card>
              <Card sx={{ border: "2px solid #FFD700", borderRadius: "8px", boxShadow: 2, height: "190px", width: "390px", marginLeft: isMobileOrTab ? 0 : "-100px" }}>
                <CardContent>
                  {data.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "4px 0",
                        borderBottom: index !== data.length - 1 ? "1px solid #FFD700" : "none",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "14px", color: "#333", marginLeft: "20px" }}>
                        {item.label}
                      </span>
                      <span style={{ fontSize: "14px", color: "#000", marginRight: "20px" }}>{item.value}</span>
                    </div>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      )}
    </Paper>
  );
};

export default BillHistory;